import { Link } from "react-router-dom";

export function Logo({ inverse = false }: { inverse?: boolean }) {
  return (
    <Link className={`brand ${inverse ? "brand--inverse" : ""}`} to="/" aria-label="Chuno home">
      <svg className="brand__mark" viewBox="0 0 36 36" aria-hidden="true">
        <path d="M28.6 8.8A13 13 0 1 0 28.6 27" fill="none" stroke="currentColor" strokeWidth="5.2" strokeLinecap="round" />
        <path d="m22.5 12.7 6 5.3-6 5.3" fill="none" stroke="currentColor" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <span>Chuno</span>
    </Link>
  );
}
